export class P6Instance {
  ID: string;
  InstanceName: string;
}
